import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Icon, Intent, InputGroup, Checkbox } from '@blueprintjs/core';
import Clearfix from 'components/elements/clearfix';
import { IconNames } from '@blueprintjs/icons';
import { createForm } from 'rc-form';
import moment from 'moment';
import styled from 'styled-components';

//* ------------------------ */

import IconRequired from 'components/elements/required-icon';
import FacilitySelect from 'components/elements/select-facility';
import DateInput from 'components/elements/date-input';
import { DATE_FORMAT, COLOR } from 'config';
import { convertDateFromSever as convertDate } from 'utils/fnUtil';
import YearSelect from 'components/elements/select-year';
import DeviceStageSelect from 'components/elements/select-device-stage';
// import dynamicRoleHOC from 'hoc/dynamicRole';

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
`;

const ColCheckBox = styled(Col)`
  display: flex;
  align-items: center;

  .bp3-checkbox {
    margin: 0;
  }
`;

// @dynamicRoleHOC()
class FacilitypermitForm extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    initialValue: PropTypes.object,
    slugBack: PropTypes.string,
    handelSubmit: PropTypes.func,
    facility: PropTypes.shape({
      _id: PropTypes.string,
      FacilityNameFull: PropTypes.string,
    }),
  };
  state = {
    isOpenNumberPermit: false,
    LicenseNumber: null,
  };

  setInitialValue(keyPath, defaultValue) {
    if (this.props.isEdit) {
      let value = _.result(this.props.initialValue, keyPath, defaultValue);
      if (!value) value = defaultValue;

      return value;
    }
    return defaultValue;
  }

  setSelInitialValue(keyPath, defaultValue, nameLabel) {
    if (this.props.isEdit) {
      let selItem = _.result(this.props.initialValue, keyPath);

      if (!selItem) return defaultValue;

      return {
        value: selItem._id,
        label: nameLabel ? selItem[nameLabel] : selItem.Name,
      };
    }

    return defaultValue;
  }

  submit = () => {
    this.props.form.validateFields((error, value) => {
      value.facility = _.get(value.facility, 'value');
      value.ProductionDate = _.get(value.ProductionDate, 'value');
      value.Stage = _.get(value.Stage, 'value');

      if (error) return;

      if (this.props.handelSubmit) this.props.handelSubmit(value);
    });
  };

  render() {
    const { getFieldProps, getFieldError } = this.props.form;

    return (
      <div>
        <h4 className='bp3-heading' style={{ color: COLOR.SUCCESS }}>
          Chi tiết Thiết Bị
        </h4>

        <Row>
          <Col xs={4}>
            <HeaderContainer>
              <Icon
                icon={IconNames.SAVED}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.PRIMARY}
                onClick={this.submit}
                style={{ color: COLOR.SUCCESS, cursor: 'pointer' }}
              />
              <Clearfix width={8} />
              {/* <Link to={this.props.slugBack ? this.props.slugBack : slug.BASE}> */}
              <Icon
                onClick={() => {
                  window.history.back();
                }}
                icon={IconNames.DISABLE}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.DANGER}
                style={{ cursor: 'pointer' }}
              />
              {/* </Link> */}
            </HeaderContainer>
          </Col>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>
              Tên cơ sở/dự án
              <IconRequired />
            </LabelContainer>
          </Col>

          <Col xs={4}>
            <FacilitySelect
              isDisabled={this.props.facility ? true : false}
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'facility',
                option: {
                  initialValue: this.props.facility
                    ? {
                        value: this.props.facility._id,
                        label: this.props.facility.FacilityNameFull,
                      }
                    : null,
                  rules: [
                    {
                      required: true,
                      message: 'Tên cơ sở/dự án is required',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('facility') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>Giai đoạn</LabelContainer>
          </Col>

          <Col xs={4}>
            <DeviceStageSelect
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'Stage',
                option: {
                  initialValue: this.setSelInitialValue('Stage'),
                },
              }}
            />
          </Col>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>
              Tên thiết bị
              <IconRequired />
            </LabelContainer>
          </Col>

          <Col xs={4}>
            <InputGroup
              placeholder='Tên thiết bị'
              {...getFieldProps('Name', {
                initialValue: this.setInitialValue('Name', ''),
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng nhập tên thiết bị',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('Name') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>Tình trạng</LabelContainer>
          </Col>

          <Col xs={4}>
            <InputGroup
              placeholder='Tình trạng'
              {...getFieldProps('Status', {
                initialValue: this.setInitialValue('Status', ''),
              })}
            />
          </Col>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>Vị trí</LabelContainer>
          </Col>

          <Col xs={4}>
            <InputGroup
              placeholder='Vị trí'
              {...getFieldProps('Location', {
                initialValue: this.setInitialValue('Location', ''),
              })}
            />
          </Col>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>Thông số kĩ thuật</LabelContainer>
          </Col>

          <Col xs={4}>
            <InputGroup
              placeholder='Thông số kĩ thuật'
              {...getFieldProps('TechnicalSpec', {
                initialValue: this.setInitialValue('TechnicalSpec', ''),
              })}
            />
            <ErrorContainer>
              {(getFieldError('TechnicalSpec') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>Năm sản xuất</LabelContainer>
          </Col>

          <Col xs={4}>
            <YearSelect
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'ProductionDate',
                option: {
                  initialValue: this.setInitialValue('ProductionDate')
                    ? {
                        value: this.setInitialValue('ProductionDate'),
                        label: this.setInitialValue('ProductionDate'),
                      }
                    : null,
                },
              }}
            />
          </Col>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>Catalog/ data sheet</LabelContainer>
          </Col>

          <ColCheckBox xs={4}>
            <Checkbox
              {...getFieldProps('IsCatalog', {
                initialValue: this.setInitialValue('IsCatalog'),
                valuePropName: 'checked',
              })}
            />
          </ColCheckBox>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>CO</LabelContainer>
          </Col>

          <ColCheckBox xs={4}>
            <Checkbox
              {...getFieldProps('IsCO', {
                initialValue: this.setInitialValue('IsCO'),
                valuePropName: 'checked',
              })}
            />
          </ColCheckBox>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>CQ</LabelContainer>
          </Col>

          <ColCheckBox xs={4}>
            <Checkbox
              {...getFieldProps('IsCQ', {
                initialValue: this.setInitialValue('IsCQ'),
                valuePropName: 'checked',
              })}
            />
          </ColCheckBox>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>Bảo trì bảo dưỡng gần nhất</LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Bảo trì bảo dưỡng gần nhất'
              {...getFieldProps('LatestMaintenanceDate', {
                initialValue: convertDate(
                  this.setInitialValue('LatestMaintenanceDate', null)
                ),
              })}
            />
            <ErrorContainer>
              {(getFieldError('LatestMaintenanceDate') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>Sửa chữa gần nhất</LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Sửa chữa gần nhất'
              {...getFieldProps('LatestRepairDate', {
                initialValue: convertDate(
                  this.setInitialValue('LatestRepairDate', null)
                ),
              })}
            />
            <ErrorContainer>
              {(getFieldError('LatestRepairDate') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>Hiệu chuẩn gần nhất</LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Hiệu chuẩn gần nhất'
              {...getFieldProps('LatestCalibrationDate', {
                initialValue: convertDate(
                  this.setInitialValue('LatestCalibrationDate', null)
                ),
              })}
            />
            <ErrorContainer>
              {(getFieldError('LatestCalibrationDate') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={4}>
            <LabelContainer>Kiểm định gần nhất</LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Kiểm định gần nhất'
              {...getFieldProps('LatestVerificationDate', {
                initialValue: convertDate(
                  this.setInitialValue('LatestVerificationDate', null)
                ),
              })}
            />
            <ErrorContainer>
              {(getFieldError('LatestVerificationDate') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>

        <Clearfix height={8} />
      </div>
    );
  }
}

export default createForm()(FacilitypermitForm);



// WEBPACK FOOTER //
// ./src/containers/FacilityDeviceContainer/FacilityDeviceForm/index.js